import { clsx } from "clsx";

import styles from "../FlowNodes.module.scss";

type FlowNodeProps = {
    selected: boolean;
    children: JSX.Element;
    connectingNodesFrom: boolean;
    isCircleNode?: boolean;
    className?: string;
};

export function BaseFlowNodeContainer({
    selected,
    children,
    connectingNodesFrom,
    isCircleNode,
    className,
}: FlowNodeProps) {
    return (
        <div className={clsx(styles.nodeWrap, className)}>
            <div
                className={clsx(styles.nodeWrapSelect, {
                    [styles.selected]: selected,
                    [styles.connectingEdge]: connectingNodesFrom,
                    [styles.circleNodeSelect]: isCircleNode,
                })}
            ></div>
            {children}
        </div>
    );
}
